import { ActionDefinition } from "components/actions/actions";
import { ComponentDefinition, DataHolderComponent, InputComponent, ValidatorComponent } from "components/components/Component";
import { RestrictionHolder } from "components/restrictions/Restrictions";
import { TableDefinitionUtils } from "../../tableDefinitionUtils";

/**
 * Fake DataHolder component that can encapsulate the row data model.
 * 
 * We need to keep a reference to the model row in order to be able to update it.
 * 
 * We need to map from a model array to an objec an way back.
 */
export class RowDataDataHolder implements DataHolderComponent, ValidatorComponent {
    public componentType = "dummyComponentDataHolder";
    public id: string;
    public definition: ComponentDefinition;
    private rowData: any[];
    public originalData;
    public children;
    tableDefinition: any;
    rowDataObject: any;
    constructor(components: InputComponent[], rowData: any[], id = undefined , tableDefinition ) {
        this.rowData = rowData;
        this.id = id;
        this.definition = {
            id,
            componentType: "dummyComponentDataHolder"
        };
        this.originalData = rowData;
        this.children = components;
        this.tableDefinition = tableDefinition;
        this.rowDataObject = TableDefinitionUtils.rowDataToObject(tableDefinition, rowData);
    }
    public selectDataForAction(action: ActionDefinition) {
        throw new Error("Method not implemented.");
    }
    public updateData(data: any): void {
        Object.assign(this.rowDataObject, data);
        // apply changes to rowData
        let newData = TableDefinitionUtils.objectToRowData(this.tableDefinition, this.rowDataObject);
        this.rowData.splice(0, newData.length, ...newData);
    }
    public setCommittedStatus(): void {
        throw new Error("Method not implemented.");
    }
    public render(): Element {
        throw new Error("Method not implemented.");
    }
    public setRequired(property: string, required: boolean): void {
        throw new Error("Method not implemented. Required and optional dependency types are not implemented for table rows. They must be implemented as server side validation.");
    }
    public initRestrictions(restrictions: RestrictionHolder): void {
        throw new Error("Method not implemented.");
    }

}